/* eslint-disable */

export enum DisplayType {
	Critical = 0,
	Warning = 1,
	Information = 2,
	Blackfriday = 3,
	Success = 4,
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.components.AlertNotification.AlertNotification
*/
export interface AlertNotification {
	message: string;
	displayType: DisplayType;
	url?: string;
}
